import React, { useState } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&family=Syne:wght@600;700&display=swap');

  .flow-root {
    font-family: 'DM Sans', sans-serif;
    background: #0b0d11;
    color: #e8eaf0;
    padding: 0 0 80px;
  }

  .flow-header {
    padding: 60px 32px 40px;
    text-align: center;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    background: linear-gradient(180deg, #111520 0%, #0b0d11 100%);
  }

  .flow-eyebrow {
    font-size: 11px;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: #ff6b35;
    font-weight: 500;
    margin-bottom: 14px;
  }

  .flow-header h2 {
    font-family: 'Syne', sans-serif;
    font-size: clamp(26px, 4vw, 42px);
    font-weight: 700;
    color: #fff;
    line-height: 1.15;
    margin-bottom: 12px;
  }

  .flow-subtitle {
    font-size: 15px;
    color: #7b8198;
    max-width: 500px;
    margin: 0 auto;
    line-height: 1.7;
  }

  .step-nav {
    display: flex;
    gap: 8px;
    justify-content: center;
    flex-wrap: wrap;
    padding: 32px 20px 0;
  }

  .step-pill {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px 6px 8px;
    border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.07);
    background: #13161d;
    cursor: pointer;
    transition: all .25s;
    font-size: 12px;
    font-weight: 500;
    color: #7b8198;
    font-family: 'DM Sans', sans-serif;
  }

  .step-pill:hover {
    border-color: rgba(255,107,53,.4);
    color: #e8eaf0;
  }

  .step-pill.active {
    background: #ff6b35;
    border-color: #ff6b35;
    color: #fff;
  }

  .pill-num {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: rgba(255,255,255,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .progress-wrap {
    max-width: 800px;
    margin: 20px auto 0;
    padding: 0 20px;
  }

  .progress-track {
    height: 2px;
    background: rgba(255,255,255,0.07);
    border-radius: 99px;
    overflow: hidden;
  }

  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #ff6b35, #ffaa5e);
    border-radius: 99px;
    transition: width .4s cubic-bezier(.4,0,.2,1);
  }

  .step-card {
    max-width: 800px;
    margin: 28px auto 0;
    padding: 0 20px;
  }

  .card-inner {
    background: #1a1e28;
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 20px;
    overflow: hidden;
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: 440px;
    animation: fadeSlideIn .35s ease;
  }

  @keyframes fadeSlideIn {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .card-visual {
    position: relative;
    overflow: hidden;
    min-height: 320px;
    background: linear-gradient(135deg, #1a1e28, #13161d);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .card-visual img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform .6s cubic-bezier(.4,0,.2,1);
  }

  .card-inner:hover .card-visual img {
    transform: scale(1.04);
  }

  .card-visual::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      rgba(11,13,17,0.45) 0%,
      rgba(11,13,17,0.1) 50%,
      rgba(11,13,17,0.55) 100%
    );
    pointer-events: none;
  }

  .img-badge {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(11,13,17,0.75);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 999px;
    padding: 6px 14px 6px 8px;
  }

  .badge-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #ff6b35;
    animation: blink 2s ease-in-out infinite;
  }

  @keyframes blink {
    0%,100% { opacity: 1; }
    50%      { opacity: .3; }
  }

  .badge-text {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #fff;
    font-family: 'DM Sans', sans-serif;
  }

  .watermark-num {
    position: absolute;
    bottom: 14px;
    right: 18px;
    z-index: 2;
    font-family: 'Syne', sans-serif;
    font-size: 72px;
    font-weight: 700;
    color: rgba(255,255,255,0.12);
    line-height: 1;
    user-select: none;
    pointer-events: none;
  }

  .card-content {
    padding: 36px 32px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    border-left: 1px solid rgba(255,255,255,0.07);
  }

  .step-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #ff6b35;
  }

  .card-title {
    font-family: 'Syne', sans-serif;
    font-size: clamp(17px, 2vw, 22px);
    font-weight: 700;
    color: #fff;
    line-height: 1.25;
  }

  .card-desc {
    font-size: 13.5px;
    color: #7b8198;
    line-height: 1.8;
  }

  .card-points {
    display: flex;
    flex-direction: column;
    gap: 9px;
    margin-top: 2px;
  }

  .card-point {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 13px;
    color: #c8cad8;
    line-height: 1.5;
  }

  .point-check {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: rgba(255,107,53,.13);
    border: 1px solid rgba(255,107,53,.3);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
  }

  .card-nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: auto;
    padding-top: 18px;
    border-top: 1px solid rgba(255,255,255,0.07);
  }

  .nav-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 9px 18px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.1);
    background: transparent;
    color: #7b8198;
    font-size: 13px;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    cursor: pointer;
    transition: all .2s;
  }

  .nav-btn:hover:not(:disabled) {
    border-color: rgba(255,107,53,.4);
    color: #e8eaf0;
  }

  .nav-btn:disabled {
    opacity: .3;
    cursor: default;
  }

  .nav-btn.next {
    background: #ff6b35;
    border-color: #ff6b35;
    color: #fff;
  }

  .nav-btn.next:hover:not(:disabled) {
    background: #ff8555;
    border-color: #ff8555;
  }

  .progress-dots {
    display: flex;
    gap: 5px;
    align-items: center;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255,255,255,0.12);
    cursor: pointer;
    transition: all .3s;
  }

  .dot.active {
    background: #ff6b35;
    width: 18px;
    border-radius: 3px;
  }

  @media (max-width: 620px) {
    .card-inner {
      grid-template-columns: 1fr;
    }
    .card-visual {
      min-height: 220px;
      border-right: none;
      border-bottom: 1px solid rgba(255,255,255,0.07);
    }
    .card-content {
      border-left: none;
      padding: 24px 20px;
    }
    .step-nav {
      gap: 6px;
    }
    .step-pill {
      font-size: 11px;
      padding: 5px 10px 5px 6px;
    }
  }
`;

const steps = [
  {
    label: "Setup",
    title: "Configure Tally Connection",
    desc: "Set up your Tally accounting data synchronization with secure API credentials and field mapping configuration.",
    points: [
      "Tally database connection setup",
      "API credential configuration",
      "Data field mapping",
      "Secure connection encryption",
    ],
  },
  {
    label: "Import",
    title: "Import Accounting Data",
    desc: "Automatically import ledgers, invoices, stock data, and transactions from Tally into your cloud system.",
    points: [
      "Automated ledger imports",
      "Invoice and bill sync",
      "Stock level synchronization",
      "Transaction history imports",
    ],
  },
  {
    label: "Sync",
    title: "Real-Time Synchronization",
    desc: "Keep data synchronized in real-time between Tally and cloud platform for accurate reporting and analysis.",
    points: [
      "Real-time data sync",
      "Transaction updates",
      "Inventory tracking",
      "Account balance synchronization",
    ],
  },
  {
    label: "Report",
    title: "Generate Reports",
    desc: "Create comprehensive financial reports, balance sheets, profit & loss, and custom analytics from synchronized data.",
    points: [
      "Financial statement generation",
      "Custom report building",
      "Multi-period comparisons",
      "Export to multiple formats",
    ],
  },
  {
    label: "Backup",
    title: "Secure Data Backup",
    desc: "Automated backup and archival of accounting data with compliance standards and disaster recovery options.",
    points: [
      "Automated daily backups",
      "Version history tracking",
      "Disaster recovery options",
      "Compliance-ready audit logs",
    ],
  },
];

const CheckIcon = () => (
  <svg width="9" height="9" viewBox="0 0 10 10" fill="none">
    <path
      d="M1.5 5L4 7.5L8.5 2.5"
      stroke="#ff6b35"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TallyFlow = () => {
  const [current, setCurrent] = useState(0);
  const step = steps[current];
  const progress = Math.round(((current + 1) / steps.length) * 100);

  const goTo = (i) => {
    if (i >= 0 && i < steps.length) setCurrent(i);
  };

  return (
    <>
      <style>{styles}</style>
      <section className="flow-root">
        <div className="flow-header">
          <p className="flow-eyebrow">TALLY SOLUTIONS FLOW</p>
          <h2>How Tally Integration Works</h2>
          <p className="flow-subtitle">
            A complete 5-step accounting system with setup, import, sync, reporting, and backup capabilities.
          </p>
        </div>

        <div className="step-nav">
          {steps.map((s, i) => (
            <button
              key={i}
              className={`step-pill${i === current ? " active" : ""}`}
              onClick={() => goTo(i)}
            >
              <span className="pill-num">{i + 1}</span>
              {s.label}
            </button>
          ))}
        </div>

        <div className="progress-wrap">
          <div className="progress-track">
            <div
              className="progress-fill"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>

        <div className="step-card">
          <div className="card-inner" key={current}>
            <div className="card-visual">
              <div className="img-badge">
                <span className="badge-dot" />
                <span className="badge-text">{step.label}</span>
              </div>
              <div className="watermark-num">0{current + 1}</div>
            </div>

            <div className="card-content">
              <div>
                <p className="step-label">
                  Step {current + 1} of {steps.length}
                </p>
                <h3 className="card-title" style={{ marginTop: 8 }}>
                  {step.title}
                </h3>
              </div>

              <p className="card-desc">{step.desc}</p>

              <div className="card-points">
                {step.points.map((pt, i) => (
                  <div className="card-point" key={i}>
                    <div className="point-check">
                      <CheckIcon />
                    </div>
                    <span>{pt}</span>
                  </div>
                ))}
              </div>

              <div className="card-nav">
                <button
                  className="nav-btn"
                  onClick={() => goTo(current - 1)}
                  disabled={current === 0}
                >
                  ← Prev
                </button>

                <div className="progress-dots">
                  {steps.map((_, i) => (
                    <div
                      key={i}
                      className={`dot${i === current ? " active" : ""}`}
                      onClick={() => goTo(i)}
                    />
                  ))}
                </div>

                <button
                  className="nav-btn next"
                  onClick={() => goTo(current + 1)}
                  disabled={current === steps.length - 1}
                >
                  Next →
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TallyFlow;
